/***
**Module Name: category
 **File Name :  category.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains category page details.
 ***/
import React, { useState, useEffect, useRef, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router";
import Footer from "../components/footer/Footer";
import InsideHeader from "../components/InnerHeader/Header";
import ReactHtmlParser from 'react-html-parser';
import $, { type } from 'jquery';
import { useForm, Controller } from "react-hook-form";
import { useParams, Link } from 'react-router-dom';
import AdvanceSearch from "./advanceSearch";
import Select from 'react-select';
import NotFound from "../pages/NotFound";
import EnquiryForm from "./EnquiryForm"
import SessionPopup from "./SessionPopup"
import Loader from "../components/loader"
import Multiselect from "multiselect-react-dropdown";
import * as Config from "../constants/Config";
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import axios from "axios";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { contentContext } from "../context/contentContext";
import InactivePopup from "./inactivePopup";
import { NavItem } from "react-bootstrap";
const CategoryContent = () => {

    const navigate = useNavigate();
    let { id } = useParams();
    const { control, handleSubmit } = useForm();
    // const [menus, setMenus] = useState([]);
    // const [grid, setGrid] = useState(true);
    const [categoryData, setCategoryData] = useState([]);
    // const [list, setList] = useState(false);
    const [config, setConfig] = useState({});
    const [data, setData] = useState([]);
    const [success, setSuccess] = useState(false);
    const [toastSuccess, setToastSuccess] = useState(false);
    // const [isShowMyContent, setIsShowMyContent] = useState(false);

    // const [showCategoryData, setShowCategoryData] = useState(true); 
    // const [categoryName, setCategoryName] = useState(""); 
    // console.log('listlistlistlistlistlist',list)

    // const [initialCategoriesData, setInitialCategoriesData] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    // const [searchTitleInput, SetSearchTitleInput] = useState('');
    // const [formValuesForContent, setFormValuesForContent] = useState([]);
    // const [wishListData, setWishListData] = useState({});
    const [wishLoad, setWishLoad] = useState(false);
    const [enquire, setEnquire] = useState(false);
    const [activeCheckId, setActiveCheckId] = useState("");
    const [activePagination, setActivePagination] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [isIdle, setIsIdle] = useState(false);
    const [sortFunFlag, setSortFunFlag] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [noDataMsg, setNoDataMsg] = useState(false);
    
    // const [searchFlag, setSearchFlag] = useState(false);
    //  console.log('activeCheckId',activeCheckId)
    let { lambda, appname } = window.app;


    const { menus, inactiveFlag,searchId, setSearchId, SetEnqFormValues, userData, searchFlag, setSearchFlag, setInactiveFlag, selectedData, setSelectedData, showCategoryData, setShowCategoryData, signedFlag, setSignedFlag, initialContent, isLoad1, setIsLoad1, initialCategoriesData1, setHideMenu, hideMenu, perPageConst, setPerPageConst, pageNumber, setPageNumber, assetTotal, setAssetTotal, perpage, setPerpage, totalPagesArray, setTotalPagesArray, totalPages, setTotalPages, setInitialCategoriesData1, isLoading, setIsLoading, clientData, wishListData, setClientData1, setWishListData, MenuCategoryName, setMenuCategoryName, isShowMyContent, setIsShowMyContent, searchPayload, setSearchPayload, searchFunActive, setSearchFunActive, welcomeMsg, setWelcomeMsg, paramType, setParamType, list, setList, grid, setGrid, wishlistCount, setwishlistCount, categorySearchPayload, setCategorySearchPayload, setCategoryFields, titleSearchPayload, setActiveFieldsObj, setTitleSearchPayload, searchTitleInput, SetSearchTitleInput, activePayload, setActivePayload, setSelectedOptions, formValuesForContent, setFormValuesForContent, route, setRoute, usePrevious, contentSearchFlag, formatsClick, setFormatsClick, setContentSearchFlag, activeSortingPayload, setActiveSortingPayload, multiSessionLoad, SetMultiSessionLoad, } = useContext(contentContext);


    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute != undefined && prevRoute != route) {
            // setCurrentPage(1)
            // setRowsPerPage(15)
            setContentSearchFlag(true)


        }
    }, [prevRoute]);


    // console.log('contentSearchFlag',contentSearchFlag)
    // console.log('prevRoute',prevRoute)
    // console.log('route',route)
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setRoute("categorycontent")
        getWishlistFun()
        Categories();
        SetEnqFormValues([])
        SetMultiSessionLoad(false)
        if (formatsClick) {
            GetClientDataFunctionCat();
            setFormatsClick(false)
        }
    }, []);




    const GetClientDataFunctionCat = async () => {
        try {
            const response = await tmdbApi.getClientData({});
            if (response.result == "Client not found" || response.result == []) {
                localStorage.removeItem("token");
                localStorage.removeItem("clientid");
                localStorage.removeItem("login");
                setInactiveFlag(false)
                localStorage.removeItem("currentSessionClientTime")

                setInactiveFlag(false)
            } else if (response.result === "Client inactived") {
                setInactiveFlag(true)
            } else {
                if (response.statusCode === 200) {
                    setClientData1(response && response.result && response.result.result && response.result.result[0]);

                    setInactiveFlag(false)
                    const signedNDA = response?.result?.result?.[0]?.signednda;
                    const companyId = response?.result?.result?.[0]?.companyid;
                    const EMAILID = response?.result?.result?.[0]?.personalemail
                    console.log('user email', EMAILID)
                    window.clarity("set", "orasi_client_email", EMAILID)
                    if (signedNDA) {
                        console.log('signeddddddddddddddddddd');
                        setSignedFlag(true);
                        localStorage.setItem("signed", signedNDA);
                        handleCategoryFormatsClick('flag', { name: "FORMATS" })
                    } else {
                        setSignedFlag(false);
                        console.log('noootttttttttttttt signeddddddddddddddddddd');
                        localStorage.removeItem("signed");
                        handleCategoryFormatsClick('flag1', { name: "FORMATS" })

                    }

                    if (companyId) {
                        localStorage.setItem("companyid", companyId);
                    } else {
                        localStorage.removeItem("companyid");
                    }

                }
            }
        } catch {
            console.log("error");
        }
    };
    const AddNotify = () => toast.success('Successfully added to Cart', {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
    },)
    const RemoveNotify = () => toast.success('Removed from Cart', {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
    },)

    const searchTitleErrToast = () => toast.error('Search cannot be empty', {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
    })

    const Categories = async () => {
        clientActivity("category");
        try {
            setIsLoading2(true)
            // console.log('isLoading1', isLoading)
            const response = await tmdbApi.getCategories({});
            // console.log("Categories Categories response--------->", response.result);
            if (response?.statusCode === 200) {
                if (response?.result == "Invalid token or Expired") {
                    setIsIdle(false)
                    setShowSessionPopupup(true)
                } else if (response?.result == "Client inactived") {
                    setInactiveFlag(true)

                } else if (response?.result == "Session Already Exists") {
                    setIsIdle(true)
                    setShowSessionPopupup(true)
                } else {
                    setData(response?.result);
                    setCategoryData(response?.result)
                    // setIsLoading(false)
                    // console.log('isLoading2', isLoading)
                }
            }
        } catch {
            console.log("error");
        }
    };
    // console.log('initialCategoriesData1initialCategoriesData1',initialCategoriesData1)
    const clientActivity = (pagearrival, value) => {
        console.log("pagearrival", pagearrival)
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();

        let payload;
        if (pagearrival === "category") {
            payload = {
                "clientid": localStorage.getItem("clientid"),
                "pagename": "MARKET PLACE",
                "pageurl": window.location.href,
                "starttime": presentTime,
                "useragent": JSON.parse(localStorage.getItem("loc")),

            };
        } else if (value === "moreInfo") {
            payload = {
                "clientid": localStorage.getItem("clientid"),
                "pagename": 'MARKET PLACE',
                "pageurl": window.location.href,
                "starttime": presentTime,
                "useragent": JSON.parse(localStorage.getItem("loc")),
                "activity": {
                    "pageVisited": "Marketplace",
                    "action": "Click",
                    "time": moment().format("hh:mm A"),
                    "actionDescription": pagearrival,
                    "icon": "video_library"
                }
            }
        } else {
            payload = {
                "clientid": localStorage.getItem("clientid"),
                "pagename": 'MARKET PLACE',
                "pageurl": window.location.href,
                "starttime": presentTime,
                "useragent": JSON.parse(localStorage.getItem("loc")),

            };

        }
        let urlLink;
        if (localStorage.getItem("previousid")) {
            urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid") + "&token=" + localStorage.getItem("token")
        } else {
            urlLink = lambda + '/activity?appname=' + appname
        }

        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)

                }
            });
    }
    const previousClick = (e) => {
        e.preventDefault()
        setSortFunFlag(false)
        let k = parseInt(pageNumber)

        setPageNumber(k - 1)
    }
    const nextClick = (e) => {
        e.preventDefault()
        setSortFunFlag(false)
        let k = parseInt(pageNumber)
        setPageNumber(k + 1)
    }
    const handleCloseEnq = () => {
        setEnquire(false)
    };

    const handleEnquire = (e) => {
        setEnquire(true);
    }

    useEffect(() => {
        if (showCategoryData === false) {
            if (sortFunFlag === false)
                contentCallSubmit(activePayload, "pagination")
        }


    }, [perpage, pageNumber]);
    const handleCategoryFormatsClick = (value, item) => {

        clientActivity(item?.name)

        setShowCategoryData(false)
        setSearchFunActive(false)
        setContentSearchFlag(true)
        setTitleSearchPayload({})
        setSearchPayload({})
        SetSearchTitleInput("")
        if (item.name === "FORMATS") {
            if (value === 'flag1') {

                setSuccess(true);
                formatEmailCall()
                setShowCategoryData(true)
                setSelectedOptions([])
                setSearchPayload({})
                setCategoryFields({})
            }
            else {

                const payload = { 'category': [item.name] }
                setCategorySearchPayload(payload)
                setMenuCategoryName(item.name)
                setSelectedOptions([])
                setSearchPayload({});
                setCategoryFields({})
                setParamType("searchByCategory")
                contentCallSubmit(payload);

            }
        } else {
            const payload = { 'category': [item.name] }
            setCategorySearchPayload(payload)
            setMenuCategoryName(item.name)
            setSelectedOptions([])
            setSearchPayload((prevPayload) => ({
                ...prevPayload,
                category: [selectedData.name],
            }));
            setCategoryFields({})
            setParamType("searchByCategory")
            contentCallSubmit(payload);

        }
    }



    // console.log('pageNumber',pageNumber)
    // console.log('isloadign',isLoading)

    // console.log('pageNumber',pageNumber)
    // console.log('isloadign',isLoading)
    async function handleCategory(e, item) {
        // console.log('item.............>',item)

        // setPerpage(18)
        // setPageNumber(1)
        clientActivity(item?.name)
        // setInitialCategoriesData1([])

        setSelectedData(item)

        setShowCategoryData(false)
        setSearchFunActive(false)
        setContentSearchFlag(true)
        setTitleSearchPayload({})
        setSearchPayload({});
        SetSearchTitleInput("")

        if (item.name === "FORMATS") {
            let signed = localStorage.getItem("signed");
            console.log('signed or not in handle category', signed)
            if (signedFlag === false || signed === false || signed === "false" || signed == undefined || signed == 'undefined' || signed == "" || signed == null) {
                // if (signedFlag === false) {

                setSuccess(true);
                formatEmailCall()
                // setIsLoading(false)
                setShowCategoryData(true)
                setSelectedOptions([])
                setSearchPayload({})
                setCategoryFields({})
            }
            else {
                const payload = { 'category': [item.name] }
                setCategorySearchPayload(payload)
                setMenuCategoryName(item.name)
                // setSelectedOptions({ value: item.name, label: item.name })
                setSelectedOptions([])
                setSearchPayload({})
                setCategoryFields({})
                setParamType("searchByCategory")
                contentCallSubmit(payload);

            }
        } else {
            const payload = { 'category': [item.name] }
            setCategorySearchPayload(payload)
            setMenuCategoryName(item.name)
            // setSelectedOptions({ value: item.name, label: item.name })
            setSelectedOptions([])
            setSearchPayload((prevPayload) => ({
                ...prevPayload,
                category: [selectedData.name],
            }));
            setCategoryFields({})
            setParamType("searchByCategory")
            contentCallSubmit(payload);

        }
    }

    const formatEmailCall = () => {
        try {
            // setIsLoading(true)


            const clientid = localStorage.getItem("clientid")

            axios({
                method: 'POST',
                url: lambda + "/formatEmail?appname=" + appname + "&clientid=" + clientid,
            })
                .then(function (response) {
                    if (response?.data?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response?.data?.result == "Client inactived") {
                        setInactiveFlag(true)

                    } else {


                        console.log(response)
                    }
                });

        } catch {
            console.log("format email error");
        }
    }
    function onConfirm() {
        setSuccess(false)
        // formatEmailCall();
    };

    //const img = "https://orasi.imgix.net/orasi/client/resources/orasiv1/images/categories";
    const cardWidth2 = $(".col5-sm1").width();

    // console.log('formValuesForContent', formValuesForContent)
    const handleChangePages = (e) => {
        e.preventDefault()
        setActivePagination(true)
        let name = e.target.name;
        let value = e.target.value;
        // console.log('perpageeee=====>', perpage)
        // console.log('pageNumber======>', pageNumber)

        if (name == 'perPage') {
            setPageNumber(1)
            setPerpage(value)
        }
        if (name == 'pageNo') {
            setPageNumber(value)
        }
    }
    // const filterCategoriesFun2 = async (payload) => {
    //     try {

    //         let isThereCategoryName = payload.id == "" ? [] : [payload.id]

    //         // const response = await tmdbApi.filterCategory({ title: searchTitleInput });
    //         const response = await tmdbApi.filterCategory(payload2);
    //         if (response.statusCode === 200) {
    //             setIsLoad1(true)
    //             let data = response.result && response.result.data && response.result.data.length > 0 ? response.result.data : []
    //             if (data.length > 0) {
    //                 let assetTotal = response.result.totalUsers || 0
    //                 setAssetTotal(assetTotal)
    //                 setInitialCategoriesData1(data)
    //                 // setShowCategoryData(false)
    //                 console.log('setIsLoading(false)1', isLoading)
    //                 if (assetTotal > 0) {
    //                     let totalPages = assetTotal / perpage;
    //                     totalPages = Math.ceil(totalPages)
    //                     let totalArray = [];
    //                     for (var i = 0; i < totalPages; i++) {
    //                         totalArray.push(i + 1)
    //                     }
    //                     setTotalPagesArray(totalArray)
    //                     setTotalPages(totalPages)

    //                 }
    //             } else {
    //                 console.log('setIsLoading(false)2', isLoading)
    //                 setHideMenu(false)
    //                 setInitialCategoriesData1([])
    //                 setShowCategoryData(false)
    //                 setIsLoading(false)
    //             }

    //         }
    //     } catch {
    //         console.log("error");
    //     }
    // };
    // var showMyData = false



    const contentCallSubmit = (payload, typeOfSearch) => {


        // console.log("category call submit")

        let payloadObj = {};
        if (typeOfSearch === "sorting") {
            setSortFunFlag(true)
            payloadObj = { ...payload, perpage: perpage }
        } else {
            payloadObj = { ...payload, pageNumber: pageNumber, perpage: perpage }
        }

        // console.log('payload in contentCallSubmit',payloadObj)

        if (payload && payload.showmycontent && payload.hasOwnProperty('showmycontent')) {
            // console.log('content call showmycontent', payload)
            payloadObj = { ...payload, ...payloadObj }
            // console.log('content call showmycontent payloadObj', payloadObj)
        }

        if ((paramType == "searchByCategory" || typeOfSearch == "searchByCategory") && payload.category != "undefined" && payload.category != "" && payload.category != null) {
            setTitleSearchPayload({})


            payloadObj = { ...payload, ["category"]: payload.category, ...payloadObj }


        }
        if (Object.keys(categorySearchPayload).length > 0) {
            payloadObj = { ...categorySearchPayload, ...payload, ...payloadObj }

        }

        if (isShowMyContent === true) {
            payloadObj = { ...payloadObj, showmycontent: true }

        }
        if (payload?.sorting) {
            payloadObj = { ...payload, ...payloadObj }
        }

        payloadObj = { ...payloadObj, contentsearch: true, companyid: clientData.companyid }
        if (contentSearchFlag === false) {
            delete payloadObj.contentsearch; // Remove the key if contentSearchFlag is false
        } else {
            payloadObj.contentsearch = true; // Add or set the key to true if contentSearchFlag is true
        }
        //   console.log('contentSearchFlag',contentSearchFlag)
        //   console.log('payloadObj',payloadObj)
        //   setContentSearchFlag(true)
        setActivePayload(payloadObj)

        if (typeOfSearch === "pagination" || typeOfSearch === "sorting") {
            CommonContentCallApi(payloadObj)
        } else {
            CommonContentCallApi(payloadObj, "categoryClick")
        }


    }

    // console.log('assetTotal--->',assetTotal)
    // console.log('showCategoryData--->',showCategoryData)
    // console.log('MenuCategoryName--->',MenuCategoryName)
    // console.log('config?.common?.searchSentMail--->',config?.common?.searchSentMail)
    const advSearchCall = async (payload) => {

        const searchFields = Object.keys(payload).map(key => ({ name: key }));
        setFormValuesForContent([])
        var time = moment().format("hh:mm A");
        // console.log('adv search call')
        setMenuCategoryName("SEARCH RESULTS")
        let payloadObj = {};
        payloadObj = { ...payload, pageNumber: 1, perpage: 18, contentsearch: true, companyid: clientData.companyid }
        setActivePayload(payloadObj)
        if (config?.common?.searchSentMail == true) {
            payloadObj = { ...payloadObj, searchSentMail: config?.common?.searchSentMail }
        }
        CommonContentCallApi(payloadObj, "advancedSearch")
    }
    const titleSearchCall = async (payload) => {
        setFormValuesForContent([])
        // console.log('title search call')
        setMenuCategoryName("SEARCH RESULTS")
        let payloadObj = { ...payload, pageNumber: 1, perpage: 18, contentsearch: true, companyid: clientData.companyid }
        setActivePayload(payloadObj)
        CommonContentCallApi(payloadObj, "titlSearch")
    }

    const CommonContentCallApi = async (payload, flagType) => {
        if (isShowMyContent === true) {
            payload = { ...payload, showmycontent: true }
        }
        try {
            setIsLoading(true)
            const response = await tmdbApi.filterCategory(payload, flagType,searchId);
            if (payload.hasOwnProperty('searchSentMail')) delete payload['searchSentMail']
            setActiveSortingPayload(payload)
            setFormatsClick(false)
            if (response?.statusCode === 200) {
                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else if (response?.result == "Client inactived") {
                    setInactiveFlag(true)

                } else {
                    setIsLoad1(true)
                    let data = response?.result && response?.result?.data && response?.result?.data?.length > 0 ? response?.result?.data : []
                    if (data.length > 0) {
                        let assetTotal = response?.result?.totalContent || 0
                        setAssetTotal(assetTotal)
                        let signed = localStorage.getItem("signed");
                        let isFormatSigned = (signed === "false" || signed == undefined || signed == 'undefined' || signed == "" || signed == null) ? false : true
                        // console.log('isFormatSigned',isFormatSigned)
                        if (!isFormatSigned) {
                            data = data?.filter((eachContent) => !eachContent.category.includes('FORMATS'))
                        }

                        console.log('data in category content', data)
                        setInitialCategoriesData1(data)
                        setShowCategoryData(false)
                        // console.log('setIsLoading(false)1', isLoading)
                        if (assetTotal > 0 && perpage > 0) {
                            let totalPages = assetTotal / perpage;
                            totalPages = Math.ceil(totalPages)
                            let totalArray = [];
                            for (var i = 0; i < totalPages; i++) {
                                totalArray.push(i + 1)
                            }
                            setTotalPagesArray(totalArray)
                            setTotalPages(totalPages)
                            // setIsLoading(false)
                            setNoDataMsg(false)
                        }
                        if (response?.result?.searchId) {
                          setSearchId(response?.result?.searchId)
                        }
                    } else {
                        setAssetTotal(0)
                        // console.log('setIsLoading(false)2', isLoading)
                        setHideMenu(false)
                        setNoDataMsg(true)
                        setInitialCategoriesData1([])
                        setShowCategoryData(false)
                        // setIsLoading(false)

                    }
                }

            }
        } catch {
            setIsLoading(false)
            console.log("error");
        } finally {
            setIsLoading(false)
        }
    }



    useEffect(() => {
        if (window.site) {
            setConfig(window.site);
        }

    }, [window.site]);

    if (config?.common && config?.common?.imagesCDN) {
        var img = config?.common?.imagesCDN;
    }


    const AddSelectedItemsToWishlist = (formvaluesObj, formid) => {
        setActiveCheckId(formid)
        AddToWishlistFun(formvaluesObj)
    }
    const deleteSelectWishList = (formvaluesObj, formid) => {

        setActiveCheckId(formid)
        const payload = formvaluesObj.map(item => item?.contentid);
        const titles = formvaluesObj
            ?.filter(item => item?.title)
            ?.map(item => (item.title));

        console.log('titles', titles)
        deleteWishlistFun({ "contentid": payload }, titles)

    }
    const onClickAddToWishList = (e, item, isAddOrDelete) => {
        setActiveCheckId(item?.contentid)
        setWishLoad(true)
        if (isAddOrDelete == "Add") {


            const clientid = localStorage.getItem("clientid")
            let defaultImg = `${img}orasi/common/images/img-default.jpg`;

            let imgKey = item?.portraitimage != undefined && item?.portraitimage != "" ? "portraitimage" :
                item.landscapeimage != undefined && item?.landscapeimage != "" ? "landscapeimage"
                    : "defaultImg"

            let imgValue = item?.portraitimage != undefined && item.portraitimage != "" ? item?.portraitimage :
                item?.landscapeimage != undefined && item?.landscapeimage != "" ? item?.landscapeimage
                    : defaultImg

            const newObj = {
                clientid: clientid,
                appname: item?.appname,
                title: item?.title,
                contentid: item?.contentid,
                // thumbnail: item.thumbnail,
                [imgKey]: imgValue,

                category: item?.category,
                companyid: item?.companyid
            }

            AddToWishlistFun([newObj])
        }
        else {

            deleteWishlistFun({ "contentid": [item?.contentid] }, item?.title)
        }

    }
    const deleteWishlistFun = async (payload, titleObject) => {
        console.log('titleObject', titleObject)
        const token = localStorage.getItem("token");
        try {
            // setIsLoading(true)
            var time = moment().format("hh:mm A");


            const payloadObj = {

                ...payload, activity: {
                    pageVisited: "Marketplace",
                    action: "Removed from cart",
                    icon: "video_library",
                    time: time,
                    actionDescription: titleObject,
                }
            }
            const clientid = localStorage.getItem("clientid")

            axios({
                method: 'DELETE',
                url: lambda + "/wishlist?appname=" + appname + "&clientid=" + clientid + '&token=' + token,
                data: payloadObj,
            })
                .then(function (response) {
                    getWishlistFun()
                    RemoveNotify()
                    setWishLoad(false)
                    setFormValuesForContent([])
                });

        } catch {
            console.log("error");
        }

    }
    // console.log('search payloadddd--->',searchPayload)
    const AddToWishlistFun = async (formvaluesObj, formid) => {
        var time = moment().format("hh:mm A");

        const allTitles =
            formvaluesObj
                ?.filter(item => item?.title)
                ?.map(item => item.title)


        try {
            // setIsLoading(true)
            setWishLoad(true)
            const response = await tmdbApi.AddToWishlist({
                'cart': formvaluesObj, "activity": {
                    pageVisited: "Marketplace",
                    action: "Added to cart",
                    time: time,
                    actionDescription: allTitles,
                    icon: "video_library"
                }
            });
            if (response?.statusCode === 200) {
                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else if (response.result == "Client inactived") {
                    setInactiveFlag(true)

                } else {
                    // console.log('response result', response.result)
                    getWishlistFun()
                    setWishLoad(false)
                    setFormValuesForContent([])
                    AddNotify()
                    // console.log('formvaluesObj',formvaluesObj)
                    if (config?.client?.clientBasedSorting) {
                        if (formvaluesObj?.length > 1) {
                            let length = formvaluesObj?.length
                            let contentCompanyId = formvaluesObj[length - 1]?.companyid
                            const payload = { ...activeSortingPayload, 'sorting': contentCompanyId[0], pageNumber: 1 }
                            setSortFunFlag(true)
                            setPageNumber(1)
                            // console.log('payload in sorting when adding cart',payload)

                            contentCallSubmit(payload, "sorting")
                        } else {
                            let contentCompanyId = formvaluesObj[0]?.companyid
                            const payload = { ...activeSortingPayload, 'sorting': contentCompanyId[0], pageNumber: 1 }
                            setSortFunFlag(true)
                            setPageNumber(1)

                            // console.log('payload in sorting when adding cart',payload)
                            contentCallSubmit(payload, "sorting")
                        }
                    }

                    // setIsLoading(false)
                }

            }
        } catch {
            // setIsLoading(false)
            console.log("error");
        }

    }
    const getWishlistFun = async () => {
        try {

            const response = await tmdbApi.getWishlist();
            if (response?.statusCode === 200) {
                setIsLoad1(true)
                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else if (response?.result == "Client inactived") {
                    setInactiveFlag(true)

                } else {
                    let data = response?.result && response?.result && response?.result?.result ? response?.result?.result : []

                    if (data.length > 0) {
                        let assetTotal = response?.result?.count || 0
                        setwishlistCount(assetTotal)
                        localStorage.setItem('wishlistCount', assetTotal)
                        setWishListData(data)
                        // console.log('getWishlist result', response.result)
                    }
                    else {
                        setwishlistCount(0)
                        localStorage.setItem('wishlistCount', 0)
                        setWishListData(data)
                        // setIsLoading(false)
                        // setTimeout(function () {
                        //     setIsLoading(false)
                        // }, 2000); 
                    }
                }
                setActiveCheckId("")

            }
        } catch {
            setActiveCheckId("")
            console.log("error");
        }

    }

    function handleGrid() {
        setGrid(true);
        setList(false);

    }

    function handleList() {
        setList(true);
        setGrid(false);
    }


    const cardWidth = $(".portfolio-item").width() != undefined ? $(".portfolio-item").width() : 169;

    const handleMoreInfo = (e, value) => {

        clientActivity(value?.title, "moreInfo")
        setGrid(true);

        setList(false);
        navigate("/moreinfo/" + value.contentid);
    }
    const handleMoreInfoList = (e, value) => {
        clientActivity(value?.title)
        setList(true);
        setGrid(false);
        navigate("/moreinfo/" + value.contentid);
    }
    const handleBackButton = () => {
        // navigate("/category");
        // history.go(-1)
        // console.log('ShowCategoryData',showCategoryData)
        setInitialCategoriesData1([])
        setShowCategoryData(true)
        setSearchFunActive(true)
        setMenuCategoryName("")
        setPerpage(18)
        setPageNumber(1)
        setFormValuesForContent([])
        // console.log('ShowCategoryData', showCategoryData)

    }

    const handleChangeCheckItem = (e, item) => {

        // console.log('checked', e.target.checked)
        const clientid = localStorage.getItem("clientid")

        if (e.target.checked == true) {

            let arr = [...formValuesForContent]
            let defaultImg = `${img}orasi/common/images/img-default.jpg`;

            let imgKey = item?.portraitimage != undefined && item?.portraitimage != "" ? "portraitimage" :
                item?.landscapeimage != undefined && item?.landscapeimage != "" ? "landscapeimage"
                    : "defaultImg"

            let imgValue = item?.portraitimage != undefined && item?.portraitimage != "" ? item?.portraitimage :
                item?.landscapeimage != undefined && item?.landscapeimage != "" ? item?.landscapeimage
                    : defaultImg

            const newObj = {
                clientid: clientid,
                appname: item?.appname,
                title: item?.title,
                contentid: item?.contentid,
                // thumbnail: item.thumbnail,
                [imgKey]: imgValue,

                category: item?.category,
                companyid: item?.companyid
            }
            arr.push(newObj)
            setFormValuesForContent(arr)
        }
        else {
            let newArr = [...formValuesForContent]
            let resultArray = newArr.filter((eachitem) => eachitem.contentid !== item.contentid)
            setFormValuesForContent(resultArray)
        }
        // console.log('forrrmmvaluess', formValuesForContent)
    }
    // console.log('formvaluesss-->',formValuesForContent)
    const handleSelectAll = (e, item) => {

        // console.log('checked', e.target.checked)
        const clientid = localStorage.getItem("clientid")

        if (e.target.checked == true) {

            let arr = []
            let dummyCategoryData = initialCategoriesData1
            // arr = arr.map((each)=>{

            dummyCategoryData && dummyCategoryData.length > 0 && dummyCategoryData.map((item, i) => {


                let defaultImg = `${img}orasi/common/images/img-default.jpg`;

                let imgKey = item?.portraitimage != undefined && item?.portraitimage != "" ? "portraitimage" :
                    item?.landscapeimage != undefined && item?.landscapeimage != "" ? "landscapeimage"
                        : "defaultImg"

                let imgValue = item?.portraitimage != undefined && item?.portraitimage != "" ? item?.portraitimage :
                    item?.landscapeimage != undefined && item?.landscapeimage != "" ? item?.landscapeimage
                        : defaultImg

                const newObj = {
                    clientid: clientid,
                    appname: item?.appname,
                    title: item?.title,
                    contentid: item?.contentid,
                    // thumbnail: item.thumbnail,
                    [imgKey]: imgValue,

                    category: item?.category,
                    companyid: item?.companyid
                }
                arr.push(newObj)
                setFormValuesForContent(arr)
                //    }

            })


            // })

        }
        else {

            setFormValuesForContent([])
        }
        // console.log('forrrmmvaluess', formValuesForContent)
    }

    // console.log('grid--------->',grid)
    // console.log('list--------->',list)
    // console.log('param typee--------->',paramType)
    const onClickSetCategory = () => {
        clientActivity("category")
        // setGrid(true)
        // setList(false)
        setShowCategoryData(true)
        setMenuCategoryName("")
        setSelectedOptions([])
        setSearchPayload({})
        setSelectedData("")
        setCategoryFields({})
        setParamType("")
        setPerpage(18)
        setSearchId('')
        setPageNumber(1)
        setFormValuesForContent([])
    }

    const toggleContent = (e) => {
        // e.preventDefault()
        let isCheck = e.target.checked
        // console.log('slider slider slider slider slider slider ',isCheck)
        if (e.target.checked == true) {
            setIsShowMyContent(true)
            setPerpage(18)
            setPageNumber(1)
            setFormValuesForContent([])
            setSelectedOptions([])
            setSearchPayload({})
            setSelectedData("")
            setCategoryFields({})
            const payload = { 'showmycontent': isCheck }
            contentCallSubmit(payload)
        }
        else {
            setIsShowMyContent(false)
            setShowCategoryData(true)
            setMenuCategoryName("")
            setCategorySearchPayload({})
            setTitleSearchPayload({})
            setSearchPayload({})
            setSelectedData("")
            setSelectedOptions([])
            setSearchPayload({})
            setSelectedData("")
            setCategoryFields({})
            setFormValuesForContent([])

            setPerpage(18)
            setPageNumber(1)

        }

    }

    const handleSearchInput = (e) => {
        setSearchId('')
        // e.preventDefault()
        let value = e.target.value
        setSearchFlag(true)
        SetSearchTitleInput(value)
        if (value === "") {
            setSearchFlag(false)
        }
        // setParamType("searchByTitle")
    }
    const ClearSearch = (e) => {
        // console.log('showCategoryData--', showCategoryData)
        // if (initialCategoriesData1.length > 0 ) {
        //     SetSearchTitleInput("");
        // }
        // else{
        SetSearchTitleInput("");
        setShowCategoryData(true)
        setMenuCategoryName("")
        setSelectedOptions([])
        setSearchPayload({})
        setSelectedData("")
        setCategoryFields({})
        setPerpage(18)
        setPageNumber(1)
        setFormValuesForContent([])
        setSearchFlag(false)
        setSearchId('')
        // }
    }
    const handleKeypress = (e) => {
        //it triggers by pressing the enter key

        if ((e.key === "Enter")) {
            setTimeout(function () {
                onClickTitleSearch();
            }, 1000);
        }
    };




    const onClickTitleSearch = (e) => {

        // e.preventDefault()
        if (searchTitleInput.length <= 0) {
            searchTitleErrToast()
        }
        else {

            let titleInput = searchTitleInput
            setPerpage(18)
            setPageNumber(1)
            setContentSearchFlag(true)

            let payload = { "title": titleInput, "pageNumber": 1, "perpage": 18 }
            setIsLoading(true)
            setSearchFunActive(true)
            setMenuCategoryName("")
            setSelectedOptions([])
            setSearchPayload({})
            setCategoryFields({})
            setSelectedData("")

            setCategorySearchPayload({})
            setTitleSearchPayload(payload)
            titleSearchCall(payload)

            setParamType("searchByTitle")

        }

    }

    console.log('formValuesForContent', formValuesForContent)
    const handleWelcomeMsg = () => {
        setWelcomeMsg(false)
    }
    console.log('showSessionPopupup', inactiveFlag)
    return (
        <>

            {inactiveFlag && <InactivePopup />}
            {!inactiveFlag && showSessionPopupup && <SessionPopup flag={isIdle} />}

            {welcomeMsg &&
                (<div className="welcomepopup" id="welcome-popup">
                    <div className="welcome-wrapper" id="welcome-wrapper">
                        <div className="welcome-header" id="welcome-header">
                            <img
                                src={img + "orasi/client/resources/orasiv1/images/welcome-graphic.svg"}
                                className="welcome-graphic animate__animated animate__tada"
                                id="welcome-graphic"
                            />
                            <button
                                className="modal-close"
                                onClick={handleWelcomeMsg}
                                id="welcome-close-btn"
                            >
                                <span className="material-icons" id="welcome-close-icon">close</span>
                            </button>
                        </div>
                        <div className="welcome-body" id="welcome-body">
                            {ReactHtmlParser(config?.duration)}
                        </div>
                    </div>
                </div>
                )
            }


            <Modal show={enquire} onHide={handleCloseEnq}>
                <EnquiryForm img={img} handleCloseEnq={handleCloseEnq} />
            </Modal>
            <Modal className="access-denied" show={success} >

                <div className="modal-body enquiry-form">
                    <div className="container">
                        <button className="close-btn" onClick={e => onConfirm()}><span className="material-icons">close</span></button>
                        <span className="material-icons access-denied-icon">https</span>
                        <h3>Access Denied</h3>
                        <p>You are not eligible to view this content.</p>
                        <p>Please contact administrator</p>
                        <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => onConfirm()}>close</button>
                    </div>
                </div>

            </Modal>
            <InsideHeader />



            <div className="inner-body">

                <div className="body-wrapper">
                    <AdvanceSearch advSearchCall={advSearchCall} selectedData={selectedData} categoryData={categoryData} />

                    <div className="main-block" id="category-content-main-block">
                        <div className="block-header" id="category-content-header">

                            {/* {hideMenu === true ? ( */}

                            <div className="title-wrapper" id="title-wrapper">
                                <div className="block-title" id="block-title">
                                    <h2 id="block-title-heading">
                                        {`${!MenuCategoryName ? 'Categories' : MenuCategoryName}`}
                                    </h2>

                                    <ul className="bread-crumbs" id="bread-crumbs">
                                        <button
                                            onClick={onClickSetCategory}
                                            id="bread-crumbs-category-btn"
                                        >
                                            <li key="key" id="bread-crumbs-category-li">Categories</li>
                                        </button>

                                        {showCategoryData ? null : MenuCategoryName != "" ? (
                                            <li
                                                key={MenuCategoryName}
                                                id="bread-crumbs-subcategory-li"
                                            >
                                                {MenuCategoryName}
                                            </li>
                                        ) : null}
                                    </ul>
                                </div>


                                {formValuesForContent && formValuesForContent?.length > 0 && list ?
                                    (<div className="title-action">
                                        <button className="plain-btn color-btn" onClick={(e) => AddSelectedItemsToWishlist(formValuesForContent, "formvaluesId")}>
                                            {activeCheckId === "formvaluesId" ? (<img src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) :
                                                <span className="material-icons plus">add</span>}

                                            Cart</button>





                                    </div>) : null}
                                {formValuesForContent && formValuesForContent?.length > 1 && wishListData?.length > 0 && list ?
                                    (<div className="title-action">

                                        <button className="plain-btn color-btn delete-button" onClick={(e) => deleteSelectWishList(formValuesForContent, "deleteAllId")}>
                                            {activeCheckId === "deleteAllId" ? (<img src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) :
                                                <span className="material-icons-outlined plus">delete_outline</span>}

                                            Remove Selected</button>





                                    </div>) : null}

                            </div>











                            <div className="body-actions">


                                {paramType != "advancedSearch" &&
                                    <div className="search-block" id="search-block">
                                        <input
                                            type="text"
                                            className="searchinput"
                                            id="search-input"
                                            placeholder="Search Content"
                                            value={searchTitleInput}
                                            onChange={(e) => handleSearchInput(e)}
                                            onKeyPress={handleKeypress}
                                        />
                                        <button
                                            className={searchFlag ? "clear-btn show" : "clear-btn"}
                                            id="clear-search-btn"
                                            onClick={ClearSearch}
                                        >
                                            <span className="material-symbols-outlined" id="clear-icon">close</span>
                                        </button>
                                        <button
                                            className="fill_btn float-end"
                                            type="submit"
                                            id="search-btn"
                                            onClick={onClickTitleSearch}
                                        >
                                            <span className="material-symbols-outlined" id="search-icon">search</span>
                                        </button>
                                    </div>


                                }

                            </div>
                        </div>


                        <div className="block-body" id="category-content-block">
                            <div className="tab-header" id="tab-header">
                                {(clientData && clientData.type == "BOTH") ?
                                    (

                                        <div className="title-wrapper" id="title-wrapper">
                                            <div className="switch-buttons" id="switch-buttons">
                                                <label className="switch" id="content-switch-label">
                                                    <input
                                                        type="checkbox"
                                                        checked={isShowMyContent}
                                                        onChange={(e) => toggleContent(e)}
                                                        id="content-switch-checkbox"
                                                    />
                                                    <span className="slider round" id="content-switch-slider"></span>
                                                </label>
                                                <span className="switch-title" id="content-switch-title">Show My Content</span>
                                            </div>
                                        </div>

                                    ) : null}

                                {!showCategoryData && initialCategoriesData1?.length > 0 ? (

                                    <div className="btn-group view-btns ms-2" id="view-buttons">
                                        <button
                                            type="button"
                                            className={`btn tablinks ${grid ? 'active' : ''}`}
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="bottom"
                                            title="Grid View"
                                            onClick={handleGrid}
                                            id="grid-view-btn"
                                        >
                                            <span className="material-symbols-outlined" id="grid-view-icon">
                                                grid_view
                                            </span>
                                        </button>

                                        <button
                                            type="button"
                                            className={`btn tablinks ${list ? 'active' : ''}`}
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="bottom"
                                            title="List View"
                                            onClick={handleList}
                                            id="list-view-btn"
                                        >
                                            <span className="material-symbols-outlined" id="list-view-icon">
                                                list
                                            </span>
                                        </button>
                                    </div>

                                ) : null}
                            </div>
                            {!isLoading ? <>
                                {assetTotal > 0 && <>
                                    {!showCategoryData && MenuCategoryName == "SEARCH RESULTS" &&
                                        <h6>{assetTotal}{assetTotal == 1 ? ' Title' : ' Titles'}  Found</h6>}</>}
                            </> : null}
                            {showCategoryData ? (
                                <>
                                    <div className="row new-category-wrapper" id="category-row" data-testid="category-row">
                                        {data && data?.length > 0 ? (
                                            <>
                                                {data &&
                                                    data?.length > 0 &&
                                                    data?.map(function (item, i) {
                                                        let signed = localStorage.getItem("signed");
                                                        let isFormatSigned =
                                                            item?.name === "FORMATS" &&
                                                                (signed === "false" ||
                                                                    signed == undefined ||
                                                                    signed == "undefined" ||
                                                                    signed == "" ||
                                                                    signed == null)
                                                                ? true
                                                                : false;

                                                        return (
                                                            <div
                                                                className="col-md-3"
                                                                id={`category-col-${i}`}
                                                                data-testid={`category-col-${i}`}
                                                                key={`category-${i}`}
                                                            >
                                                                <div
                                                                    className="new-category-thumb"
                                                                    id={`category-thumb-${i}`}
                                                                    data-testid={`category-thumb-${i}`}
                                                                    onClick={(e) => handleCategory(e, item)}
                                                                >
                                                                    {isFormatSigned ? (
                                                                        <span
                                                                            className="material-icons lock-icon"
                                                                            id={`lock-icon-${i}`}
                                                                            data-testid={`lock-icon-${i}`}
                                                                        >
                                                                            lock
                                                                        </span>
                                                                    ) : null}
                                                                    <img
                                                                        src={item?.image}
                                                                        alt="movies-thumb"
                                                                        className="thumb-img"
                                                                        id={`thumb-img-${i}`}
                                                                        data-testid={`thumb-img-${i}`}
                                                                    />
                                                                    <div
                                                                        className="thumb-content"
                                                                        id={`thumb-content-${i}`}
                                                                        data-testid={`thumb-content-${i}`}
                                                                    >
                                                                        <img
                                                                            src={item?.icon}
                                                                            alt="movies-thumb"
                                                                            className="thumb-icon"
                                                                            id={`thumb-icon-${i}`}
                                                                            data-testid={`thumb-icon-${i}`}
                                                                        />
                                                                        <h3
                                                                            className="thumb-title"
                                                                            id={`thumb-title-${i}`}
                                                                            data-testid={`thumb-title-${i}`}
                                                                        >
                                                                            {item?.name}
                                                                        </h3>


                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </>
                                        ) : isLoading2 ? (
                                            <div className="orasi-preloader" id="category-preloader" data-testid="category-preloader">
                                                <img
                                                    src={"https://d2aif2zmoi437u.cloudfront.net/orasi/common/images/preloader.png"}
                                                    id="category-preloader-img"
                                                    data-testid="category-preloader-img"
                                                    alt="preloader"
                                                />
                                            </div>
                                        ) : null}
                                    </div>


                                </>) : (<>


                                    {grid ?

                                        !isLoading && initialCategoriesData1 && initialCategoriesData1?.length > 0 ? (<>

                                            <div className="grid-view tabcontent" id="grid-view">

                                                <div className="row portfolio">
                                                    {
                                                        isLoading ? (
                                                            <div className="orasi-preloader">
                                                                <img src={"https://d2aif2zmoi437u.cloudfront.net/orasi/common/images/preloader.png"} />
                                                            </div>
                                                        )
                                                            :
                                                            initialCategoriesData1 && Object.keys(initialCategoriesData1)?.length > 0 && initialCategoriesData1.map((item, i) => {

                                                                let picName = item.mediaType === 'video' ? 'videoclip-defaulr' : item?.mediaType === 'audio' ? 'musicfile-default' : item?.mediaType === 'pdf' ? 'pdf-default' : item?.mediaType === 'doc' ? 'doc-defaulr' : 'img-default'
                                                                // let defaultImg = `https://d9nwtjplhevo0.cloudfront.net/orasi/common/images/${picName}.jpg`;
                                                                let defaultImg = `${img}orasi/common/images/img-default.jpg`;



                                                                const imgUrl = (item?.portraitimage || item?.landscapeimage)
                                                                    ? ((item?.portraitimage?.startsWith("http")) ||
                                                                        (item?.landscapeimage?.startsWith("http")))
                                                                        ? (item?.portraitimage || item?.landscapeimage)
                                                                        : img + (item?.portraitimage || item?.landscapeimage)
                                                                    : defaultImg;


                                                                let wishListActive = wishListData && wishListData?.length > 0 ? wishListData?.filter((eachitem) => eachitem?.contentid == item?.contentid) : {}
                                                                let isAddOrDelete = wishListActive && wishListActive?.length > 0 ? 'Delete' : 'Add'


                                                                const categoryItem = Array.isArray(item?.category) ? item?.category?.join(', ') : item?.category || '';


                                                                return (
                                                                    <div
                                                                        className="col6-sm1 col-md-6 portfolio-item"
                                                                        key={i}
                                                                        id={`portfolio-item-${i}`}
                                                                    >
                                                                        <div
                                                                            className="portfolio-wrap"
                                                                            style={{ cursor: "pointer" }}
                                                                            id={`portfolio-wrap-${i}`}
                                                                        >
                                                                            <img
                                                                                src={imgUrl + "?auto=compress,format&width=" + cardWidth + "&q=95"}
                                                                                className="asset-portrait-thumb"
                                                                                alt=""
                                                                                onClick={(e) => handleMoreInfo(e, item)}
                                                                                id={`portfolio-img-${i}`}
                                                                            />

                                                                            <div
                                                                                className="portfolio-info black-gradient"
                                                                                id={`portfolio-info-${i}`}
                                                                            >
                                                                                <div
                                                                                    className="thumb-info-block black-gradient"
                                                                                    id={`thumb-info-block-${i}`}
                                                                                >
                                                                                    <div className="thumb-info" id={`thumb-info-${i}`}>
                                                                                        <h6
                                                                                            className="thumb-title"
                                                                                            style={{ cursor: "pointer" }}
                                                                                            onClick={(e) => handleMoreInfo(e, item)}
                                                                                            id={`thumb-title-${i}`}
                                                                                        >
                                                                                            {item.title}
                                                                                        </h6>
                                                                                        {item?.foreigntitle && <p>({item.foreigntitle})</p>}
                                                                                        {item?.category ? (
                                                                                            <h6
                                                                                                className="sub-title"
                                                                                                style={{ cursor: "pointer" }}
                                                                                                onClick={(e) => handleMoreInfo(e, item)}
                                                                                                id={`thumb-sub-title-${i}`}
                                                                                            >
                                                                                                {categoryItem}
                                                                                            </h6>
                                                                                        ) : null}

                                                                                        <ul
                                                                                            className="thumb-meta"
                                                                                            style={{ cursor: "pointer" }}
                                                                                            onClick={(e) => handleMoreInfo(e, item)}
                                                                                            id={`thumb-meta-${i}`}
                                                                                        >
                                                                                            {item?.duration ? <li id={`thumb-duration-${i}`}>{item?.duration}</li> : null}

                                                                                            {
                                                                                                // item?.releasedate ? (
                                                                                                //     <li id={`thumb-release-date-${i}`}>
                                                                                                //         {item?.releasedate && moment(item?.releasedate).format("DD-MMM-YY")}
                                                                                                //     </li>
                                                                                                // ) 
                                                                                                // : 
                                                                                                item?.releaseyear ? (
                                                                                                    <li id={`thumb-release-year-${i}`}>{item?.releaseyear}</li>
                                                                                                ) : null}

                                                                                            {item?.keywords ? (
                                                                                                <li id={`thumb-keywords-${i}`}>{item?.keywords}</li>
                                                                                            ) : null}
                                                                                        </ul>

                                                                                        <p
                                                                                            className="thumb-description"
                                                                                            style={{ cursor: "pointer" }}
                                                                                            onClick={(e) => handleMoreInfo(e, item)}
                                                                                            id={`thumb-description-${i}`}
                                                                                        >
                                                                                            {item.synopsis}
                                                                                        </p>

                                                                                        {!isShowMyContent && clientData && clientData.type != "SELLER" ? (
                                                                                            <button
                                                                                                style={{ cursor: "pointer", zIndex: 1 }}
                                                                                                className={`table-actions-btn border-btn_sm ${wishListActive && wishListActive.length > 0 ? "active" : ""
                                                                                                    }`}
                                                                                                onClick={(e) => onClickAddToWishList(e, item, isAddOrDelete)}
                                                                                                id={`wishlist-btn-${i}`}
                                                                                            >
                                                                                                {wishListActive && wishListActive.length > 0 ? (
                                                                                                    activeCheckId === item?.contentid ? (
                                                                                                        <img
                                                                                                            src={
                                                                                                                img +
                                                                                                                "orasi/client/resources/orasiv1/images/common-icons/rotate_right-white.svg "
                                                                                                            }
                                                                                                            className="loading-icon"
                                                                                                            id={`wishlist-loading-icon-${i}`}
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <span
                                                                                                            className="material-icons"
                                                                                                            id={`wishlist-check-icon-${i}`}
                                                                                                        >
                                                                                                            check_circle
                                                                                                        </span>
                                                                                                    )
                                                                                                ) : activeCheckId === item?.contentid ? (
                                                                                                    <img
                                                                                                        src={
                                                                                                            img +
                                                                                                            "orasi/client/resources/orasiv1/images/common-icons/rotate_right-white.svg"
                                                                                                        }
                                                                                                        className="loading-icon"
                                                                                                        id={`wishlist-loading-icon-${i}`}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <span
                                                                                                        className="material-symbols-outlined done"
                                                                                                        id={`wishlist-cart-icon-${i}`}
                                                                                                    >
                                                                                                        shopping_cart
                                                                                                    </span>
                                                                                                )}
                                                                                                CART
                                                                                            </button>
                                                                                        ) : null}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                )
                                                            })}


                                                </div>

                                                {assetTotal > perPageConst ?
                                                    <div className="row pagenation pgn1" id="pagination-row">
                                                        <div className="pagenation_prv" id="pagination-prev-wrapper">
                                                            <button
                                                                disabled={pageNumber == 1}
                                                                onClick={(e) => previousClick(e)}
                                                                className="jr-btn btn-white btn btn-default btn-block"
                                                                id="pagination-prev-btn"
                                                            >
                                                                Previous
                                                            </button>
                                                        </div>

                                                        <div className="pagenation_page" id="pagination-page-wrapper">
                                                            <label id="pagination-page-label">Page :</label>

                                                            <select
                                                                className="form-control custom-select u-w60 custom-select custom-select-sm form-control form-control-sm form-select form-select-sm"
                                                                value={pageNumber}
                                                                name="pageNo"
                                                                onChange={(e) => handleChangePages(e)}
                                                                id="pagination-page-select"
                                                            >
                                                                {totalPagesArray &&
                                                                    totalPagesArray.map(function (item, i) {
                                                                        return (
                                                                            <option key={i} value={item} id={`pagination-page-option-${item}`}>
                                                                                {item}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>

                                                            <label id="pagination-total-label">
                                                                <strong> of {totalPages}</strong>
                                                            </label>
                                                        </div>

                                                        <div className="pagenation_count" id="pagination-count-wrapper">
                                                            <label id="pagination-count-label">
                                                                {(pageNumber * perpage) >= assetTotal
                                                                    ? assetTotal
                                                                    : pageNumber * perpage}{" "}
                                                                of {assetTotal}
                                                            </label>
                                                        </div>

                                                        <div className="pagenation_perpage" id="pagination-perpage-wrapper">
                                                            <label id="pagination-perpage-label">Per Page:</label>

                                                            <select
                                                                className="form-control custom-select u-w60 custom-select custom-select-sm form-control form-control-sm form-select form-select-sm"
                                                                name="perPage"
                                                                value={perpage}
                                                                onChange={(e) => handleChangePages(e)}
                                                                id="pagination-perpage-select"
                                                            >
                                                                <option value={18} id="pagination-perpage-18">18</option>
                                                                <option value={36} id="pagination-perpage-36">36</option>
                                                                <option value={54} id="pagination-perpage-54">54</option>
                                                                <option value={72} id="pagination-perpage-72">72</option>
                                                                <option value={90} id="pagination-perpage-90">90</option>
                                                                <option value={108} id="pagination-perpage-108">108</option>
                                                            </select>
                                                        </div>

                                                        <div className="pagenation_next" id="pagination-next-wrapper">
                                                            <button
                                                                disabled={pageNumber == totalPages}
                                                                onClick={(e) => nextClick(e)}
                                                                className="jr-btn btn-white btn btn-default btn-block"
                                                                id="pagination-next-btn"
                                                            >
                                                                Next
                                                            </button>
                                                        </div>
                                                    </div>
                                                    : null

                                                }
                                                {/* </>) } */}
                                            </div>

                                        </>) : isLoading ? (
                                            <div className="orasi-preloader">
                                                <img src={"https://d2aif2zmoi437u.cloudfront.net/orasi/common/images/preloader.png"} />
                                            </div>
                                        )
                                            : !isLoading && noDataMsg && initialCategoriesData1.length <= 0 &&
                                            <div className="searchfail-block">
                                                <img src={img + "orasi/common/images/search-fail.png"} className="searchfail-graphic mt-5" />
                                                <h6>Sorry, We couldn't find what you are looking for</h6>
                                                <p>Please try another way</p>
                                                <button className="fill_btn yellow-gradient" onClick={handleBackButton}>Go Back</button>
                                            </div>
                                        : null}




                                    {list ?

                                        !isLoading && initialCategoriesData1 && initialCategoriesData1.length > 0 ? (<>

                                            <div
                                                className={`${clientData.type === "SELLER" ? "seller-list-view" : ""} list-view tabcontent`}
                                                id="list-view"
                                            >
                                                <div className="table-responsive">
                                                    <table
                                                        className={`table table-bordered asset-list-table ${isShowMyContent ? "show-my-content" : ""
                                                            }`}
                                                        id="asset-list-table"
                                                    >
                                                        <thead id="asset-table-head">
                                                            <tr id="asset-table-head-row">
                                                                {!isShowMyContent && clientData && clientData.type != "SELLER" ? (
                                                                    <th>
                                                                        <input
                                                                            type="checkbox"
                                                                            id="select-all-checkbox"
                                                                            checked={
                                                                                formValuesForContent?.length === initialCategoriesData1?.length
                                                                            }
                                                                            onChange={(e) => handleSelectAll(e)}
                                                                        />
                                                                    </th>
                                                                ) : null}
                                                                <th id="title-header">Title</th>
                                                                <th id="release-year-header">Release Year</th>
                                                                <th id="genre-header">Genre</th>
                                                                <th id="duration-header">Duration</th>
                                                                <th id="director-header">Director</th>
                                                                <th id="description-header">Description</th>
                                                                <th id="cast-header">Cast</th>
                                                                <th id="category-header">Category</th>
                                                                {!isShowMyContent && clientData && clientData?.type != "SELLER" ? (
                                                                    <th id="add-to-cart-header">Add to Cart</th>
                                                                ) : null}
                                                            </tr>
                                                        </thead>
                                                        <tbody id="asset-table-body">
                                                            {initialCategoriesData1 &&
                                                                initialCategoriesData1.length > 0 &&
                                                                initialCategoriesData1?.map((item, i) => {
                                                                    let isCartAdd = item.cart == true ? true : false;

                                                                    let wishListActive =
                                                                        wishListData && wishListData?.length > 0
                                                                            ? wishListData?.filter(
                                                                                (eachitem) => eachitem?.contentid == item?.contentid
                                                                            )
                                                                            : {};
                                                                    let isAddOrDelete =
                                                                        wishListActive && wishListActive?.length > 0 ? "Delete" : "Add";

                                                                    const director = Array.isArray(item?.director)
                                                                        ? item.director.join(", ")
                                                                        : item?.director || "";
                                                                    const genre = Array.isArray(item?.genre)
                                                                        ? item.genre.join(", ")
                                                                        : item?.genre || "";
                                                                    const cast = Array.isArray(item?.cast)
                                                                        ? item.cast.join(", ")
                                                                        : item?.cast || "";
                                                                    const categoryItem = Array.isArray(item?.category)
                                                                        ? item?.category?.join(", ")
                                                                        : item?.category || "";

                                                                    let picName =
                                                                        item?.mediaType === "video"
                                                                            ? "videoclip-defaulr"
                                                                            : item?.mediaType === "audio"
                                                                                ? "musicfile-default"
                                                                                : item?.mediaType === "pdf"
                                                                                    ? "pdf-default"
                                                                                    : item?.mediaType === "doc"
                                                                                        ? "doc-defaulr"
                                                                                        : "img-default";
                                                                    let defaultImg = `${img}orasi/common/images/${picName}.jpg`;

                                                                    const imgUrl =
                                                                        item?.portraitimage || item?.landscapeimage
                                                                            ? item?.portraitimage?.startsWith("http") ||
                                                                                item?.landscapeimage?.startsWith("http")
                                                                                ? item?.portraitimage || item?.landscapeimage
                                                                                : img + (item?.portraitimage || item?.landscapeimage)
                                                                            : defaultImg;

                                                                    const filterList = formValuesForContent?.filter(
                                                                        (each) => each?.contentid === item?.contentid
                                                                    );
                                                                    const isCheck = Boolean(filterList[0]?.title);

                                                                    return (
                                                                        <tr
                                                                            key={item?.contentid}
                                                                            className={`${isCheck ? "active" : ""}`}
                                                                            id={`asset-row-${item?.contentid}`}
                                                                        >
                                                                            {!isShowMyContent && clientData && clientData.type != "SELLER" ? (
                                                                                <td>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`row-checkbox-${item?.contentid}`}
                                                                                        checked={isCheck}
                                                                                        onChange={(e) => handleChangeCheckItem(e, item)}
                                                                                    />
                                                                                </td>
                                                                            ) : null}

                                                                            <td
                                                                                id={`asset-title-${item?.contentid}`}
                                                                                onClick={(e) => handleMoreInfoList(e, item)}
                                                                            >
                                                                                <div className="title-name">
                                                                                    <div className="table-thumb me-1">
                                                                                        <img
                                                                                            id={`asset-img-${item?.contentid}`}
                                                                                            src={
                                                                                                imgUrl + "?auto=compress,format&width=" + cardWidth
                                                                                            }
                                                                                            alt=""
                                                                                        />
                                                                                    </div>{" "}
                                                                                    <p id={`asset-title-text-${item?.contentid}`}>
                                                                                        {item?.title}
                                                                                    </p>
                                                                                </div>
                                                                            </td>

                                                                            <td
                                                                                id={`asset-release-${item?.contentid}`}
                                                                                onClick={(e) => handleMoreInfoList(e, NavItem)}
                                                                            >
                                                                                {item?.releaseyear
                                                                                    ? item?.releaseyear
                                                                                    : item?.releasedate
                                                                                        ? moment(item?.releasedate).format("DD-MMM-YY")
                                                                                        : ""}
                                                                            </td>

                                                                            <td
                                                                                id={`asset-genre-${item?.contentid}`}
                                                                                onClick={(e) => handleMoreInfoList(e, item)}
                                                                            >
                                                                                <div className="cast">{genre}</div>
                                                                            </td>

                                                                            <td
                                                                                id={`asset-duration-${item?.contentid}`}
                                                                                onClick={(e) => handleMoreInfoList(e, item)}
                                                                            >
                                                                                {item?.duration}
                                                                            </td>
                                                                            <td id={`asset-director-${item?.contentid}`}>{director}</td>

                                                                            <td
                                                                                id={`asset-description-${item?.contentid}`}
                                                                                onClick={(e) => handleMoreInfoList(e, item)}
                                                                            >
                                                                                <div className="cast">{item?.synopsis}</div>
                                                                            </td>
                                                                            <td
                                                                                id={`asset-cast-${item?.contentid}`}
                                                                                onClick={(e) => handleMoreInfoList(e, item)}
                                                                            >
                                                                                <div className="cast">{cast}</div>
                                                                            </td>
                                                                            <td
                                                                                id={`asset-category-${item?.contentid}`}
                                                                                onClick={(e) => handleMoreInfoList(e, item)}
                                                                            >
                                                                                <span className="sm-badge cast">{categoryItem}</span>
                                                                            </td>
                                                                            {!isShowMyContent && clientData && clientData.type != "SELLER" ? (
                                                                                <td>
                                                                                    <div
                                                                                        className="table-actions-group add-btn"
                                                                                        id={`asset-cart-${item?.contentid}`}
                                                                                    >
                                                                                        <button
                                                                                            id={`cart-btn-${item?.contentid}`}
                                                                                            className={`table-actions-btn ${wishListActive && wishListActive?.length > 0
                                                                                                ? "active"
                                                                                                : ""
                                                                                                }`}
                                                                                            onClick={(e) =>
                                                                                                onClickAddToWishList(e, item, isAddOrDelete)
                                                                                            }
                                                                                        >
                                                                                            {wishListActive && wishListActive?.length > 0 ? (
                                                                                                activeCheckId === item.contentid ? (
                                                                                                    <img
                                                                                                        id={`cart-loading-${item?.contentid}`}
                                                                                                        src={
                                                                                                            img +
                                                                                                            "orasi/client/resources/orasiv1/images/common-icons/rotate_right-white.svg "
                                                                                                        }
                                                                                                        className="loading-icon"
                                                                                                    />
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <span className="material-icons">shopping_cart</span>
                                                                                                        <span className="material-icons done">done</span>
                                                                                                    </>
                                                                                                )
                                                                                            ) : activeCheckId === item?.contentid ? (
                                                                                                <img
                                                                                                    id={`cart-loading-${item?.contentid}`}
                                                                                                    src={
                                                                                                        img +
                                                                                                        "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"
                                                                                                    }
                                                                                                    className="loading-icon"
                                                                                                />
                                                                                            ) : (
                                                                                                <span className="material-symbols-outlined">
                                                                                                    shopping_cart
                                                                                                </span>
                                                                                            )}
                                                                                        </button>
                                                                                    </div>
                                                                                </td>
                                                                            ) : null}
                                                                        </tr>
                                                                    );
                                                                })}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {assetTotal > perPageConst ? (
                                                    <div className="row pagenation pgn1" id="pagination-block">
                                                        <div className="pagenation_prv">
                                                            <button
                                                                id="pagination-prev"
                                                                disabled={pageNumber == 1}
                                                                onClick={(e) => previousClick(e)}
                                                                className="jr-btn btn-white btn btn-default btn-block"
                                                            >
                                                                Previous
                                                            </button>
                                                        </div>
                                                        <div className="pagenation_page">
                                                            <label>Page :</label>
                                                            <select
                                                                id="pagination-select"
                                                                className="form-control custom-select u-w60 custom-select custom-select-sm form-control form-control-sm form-select form-select-sm"
                                                                value={pageNumber}
                                                                name="pageNo"
                                                                onChange={(e) => handleChangePages(e)}
                                                            >
                                                                {totalPagesArray &&
                                                                    totalPagesArray.map(function (item, i) {
                                                                        return (
                                                                            <option key={i} id={`pagination-page-${item}`} value={item}>
                                                                                {item}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                            <label>
                                                                <strong> of {totalPages}</strong>
                                                            </label>
                                                        </div>
                                                        <div className="pagenation_count" id="pagination-count">
                                                            <label>
                                                                {(pageNumber * perpage) >= assetTotal
                                                                    ? assetTotal
                                                                    : pageNumber * perpage}{" "}
                                                                of {assetTotal}
                                                            </label>
                                                        </div>
                                                        <div className="pagenation_perpage">
                                                            <label>Per Page:</label>
                                                            <select
                                                                id="pagination-perpage"
                                                                className="form-control custom-select u-w60 custom-select custom-select-sm form-control form-control-sm form-select form-select-sm"
                                                                name="perPage"
                                                                value={perpage}
                                                                onChange={(e) => handleChangePages(e)}
                                                            >
                                                                <option value={18}>18</option>
                                                                <option value={36}>36</option>
                                                                <option value={54}>54</option>
                                                                <option value={72}>72</option>
                                                                <option value={90}>90</option>
                                                                <option value={108}>108</option>
                                                            </select>
                                                        </div>
                                                        <div className="pagenation_next">
                                                            <button
                                                                id="pagination-next"
                                                                disabled={pageNumber == totalPages}
                                                                onClick={(e) => nextClick(e)}
                                                                className="jr-btn btn-white btn btn-default btn-block"
                                                            >
                                                                Next
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>


                                        </>) : isLoading ? (
                                            <div className="orasi-preloader">
                                                <img src={"https://d2aif2zmoi437u.cloudfront.net/orasi/common/images/preloader.png"} />
                                            </div>
                                        ) : !isLoading && noDataMsg && initialCategoriesData1?.length <= 0 &&
                                        <div className="searchfail-block">
                                            <img src={img + "orasi/common/images/search-fail.png"} className="searchfail-graphic mt-5" />
                                            <h6>Sorry, We couldn't find what you are looking for</h6>
                                            <p>Please try another way</p>
                                            <button className="fill_btn yellow-gradient" onClick={handleBackButton}>Go Back</button>
                                        </div>


                                        : null}
                                </>)}
                        </div>

                        <Footer menus={menus} id={"/content/" + id} />
                    </div>


                </div>

            </div>
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

        </>
    );
};

export default CategoryContent;
